import React, { useEffect, useState, CSSProperties } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import api from '../../config/Config'
import toast, { Toaster } from 'react-hot-toast';
import requestRow from '../../controller/RequestRow';
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { Badge, Pagination, Modal, Drawer, Input } from 'antd';
import { Space, Card, Statistic, Row, Col, Typography } from "antd";
import {
    CheckCircleOutlined,
    CloseCircleOutlined, HddOutlined, FileDoneOutlined,
    SearchOutlined, FileExcelOutlined, MoreOutlined
} from "@ant-design/icons"
import { logoLight } from '../../components/icons';
import Footer from '../../components/footer';
import Header from '../../components/header';
const { Title } = Typography;

const VoucherDistribution = () => {
    const theme = useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const navigate = useNavigate();
    const data = ''

    const [inventory, setInventory] = useState<requestRow[]>([])

    const [phone, setPhone] = useState('');
    const [id, setId] = useState('');
    const [nameSeller, steNameSeller] = useState('');

    //Load Assigned Details
    const [countAllPins, setCountAllPins] = useState('');
    const [countSubContractore, setCountSubContractore] = useState('');
    const [countUsedDonomination, setCountUsedDonomination] = useState('');
    const [countUnsedDonomination, setCountUnsedDonomination] = useState('');
    const [countSupervisor, setCountSupervisor] = useState('');
    const [countAgent, setCountAgent] = useState('');
    const [countDistributor, setCountDistributor] = useState('');
    const [countVendor, setCountVendor] = useState('');

    const [nameSeler, setNameSeler] = useState('');
    const [selerRole, setSelerRole] = useState('');
    const [reference, setReference] = useState('');
    const [date, setDate] = useState('');
    const [currency, setCurrency] = useState('');
    const [donimination, setDonumination] = useState('');
    const [customerSellingPrice, setCustomerSellingPrice] = useState('');
    const [mobileOperator, setMobileOperator] = useState([]);
    const [used, setUsed] = useState('');
    const [assigned, setAssigned] = useState('');
    const [available, setAvailable] = useState('');
    const [financeUsed, setFinanceUsed] = useState('');
    const [financeSupposedReceived, setFinanceSupposedReceived] = useState('');
    const [paidAmount, setPaidAmount] = useState('');
    const [unpaidAmount, setUnpaidAmount] = useState('');
    const [showSellerPhone, setShowSellerPhone] = useState('');
    const [showId, setShowId] = useState('');
    const [showSellerName, setShowSellerName] = useState('');
    const [sellerIsKyc, setSellerIsKyc] = useState('');
    const [sellerPhone, setSellerPhone] = useState('');
    const [sellerEmail, setSellerEmail] = useState('');
    const [sellerRole, setSellerRole] = useState('');
    const [sellerIsLicence, setSellerIsLicence] = useState('');

    //Paginate
    const [totalPage, setTotalPage] = useState(1);

    useEffect(() => {
        if (sessionStorage.getItem('onktxonktx') == null) {
            navigate('/login')
        }

        loadInventory(1)
    }, []);

    function loadInventory(page: any) {
        api.getHttpRequest(`/vouchers/partner/load-transactions-attribute?page=${page}`, data, 'GET').then((response) => {

            const json = response.data;
            setInventory(json.data.data);
            setCountAllPins(json.data.count_all_pins)
            setCountSubContractore(json.data.count_subContractore)
            setCountUsedDonomination(json.data.count_donomination.count_used_donomination)
            setCountUnsedDonomination(json.data.count_donomination.count_unsed_donomination)
            setCountSupervisor(json.data.count_supervisor)
            setCountAgent(json.data.count_agent)
            setCountDistributor(json.data.count_distributor)
            setCountVendor(json.data.count_vendor)


        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const getUsed = (x: any) => {
        if (x == true) return ['badge badge-pill bg-danger', 'Used'];
        if (x == false) return ['badge badge-pill bg-success', 'Not used'];
        return '';
    }

    const getTransfer = (x: any) => {
        if (x == true) return ['badge badge-danger', 'Transferred'];
        if (x == false) return ['badge badge-success', 'Not Transferred'];
        return '';
    }

    function geDateFormat(dateString: string): string {
        const date = new Date(Date.parse(dateString));
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        return formattedDate;
    }
    // function loadSeller(page: any) {
    //     api.getHttpRequest(`/member/load?page=${page}&size=2`, data, 'GET').then((response) => {
    //         const json = response.data;
    //         if (json.status == 200) {
    //             setSellerLoad(json.data.rows);
    //             setSearchResult(json.data.rows);
    //             setTotalPage(json.data.count);
    //         }
    //     }).catch((error) => {
    //         if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
    //             toast.error("Please connect your device to the internet");
    //         } else if (error.response && error.response.data && error.response.data.message) {
    //             toast.error(error.response.data.message);
    //         } else {
    //             toast.error(error.message);
    //         }
    //     })
    // }

    //Modal Request
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    function showModal(phone: any, id_: any, name: string) {
        setOpen(true);
        setPhone(phone);
        setId(id_);
        steNameSeller(name);
    };

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);
        }, 2000);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    //Show Dwower
    const [openDawer, setOpenDrawer] = useState(false);

    const showDrawer = (element: any) => {
        setOpenDrawer(true)
        setNameSeler(element.seller_name)
        setSelerRole(element.seller_role)
        setReference(element.reference)
        setDate(element.date)
        setCurrency(element.currency)
        setDonumination(element.donimination)
        setCustomerSellingPrice(element.customer_selling_price)
        setMobileOperator(element.mobile_operator)
        setUsed(element.status.used)
        setAssigned(element.status.asigned)
        setAvailable(element.status.available)
        setFinanceUsed(element.finance_used)
        setFinanceSupposedReceived(element.finance_supposed_received)
        setPaidAmount(element.paid_amount)
        setUnpaidAmount(element.unpaid_amount)
        setShowSellerPhone(element.seller_phone)
        setShowId(element.id)
        setShowSellerName(element.seller_name)
        setSellerIsKyc(element.seller_is_Kyc)
        setSellerPhone(element.seller_phone)
        setSellerEmail(element.seller_email)
        setSellerRole(element.seller_role)
        setSellerIsLicence(element.seller_is_Licence)

    }
    const closeDrawer = () => {
        setOpenDrawer(false)
    }

    //kEYC verify
    function VerifyKEYC(x: any): CSSProperties {
        if (x == 1) return {
            backgroundColor: '#00CE69',
            color: 'black', borderColor: '#00CE69',
            borderRadius: 5, height: 22, paddingBottom: 5,
        };
        if (x == 0) return {
            backgroundColor: 'red',
            color: 'black', borderColor: 'red',
            borderRadius: 5, height: 22, paddingBottom: 5,
        };
        return {}; // retourner un objet vide au lieu d'une chaîne vide
    }

    function VerifyLicence(x: any): CSSProperties {
        if (x == 1) return {
            backgroundColor: '#00CE69',
            color: 'black', borderRadius: 5, borderColor: '#00CE69',
            height: 22, paddingTop: 0, paddingBottom: 5,
            width: 100
        };
        if (x == 0) return {
            backgroundColor: 'red',
            color: 'black', borderRadius: 5, borderColor: 'red',
            height: 22, paddingTop: 0, paddingBottom: 5,
            width: 100
        };
        return {}; // retourner un objet vide au lieu d'une chaîne vide
    }

    return (
        <>


            <div id="wrapper">

                <Header />
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid1">

                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        <h2 className="header-title pb-0 font-30 border-none">Vouchers assigned
                                        </h2>
                                        <div style={{ display: 'flex', marginLeft: 10, paddingBottom: 10 }}>
                                            <label style={{
                                                backgroundColor: '#4920E9',
                                                height: 20,
                                                width: 6,
                                                borderRadius: 10
                                            }}></label>
                                            <strong style={{ paddingLeft: 2 }}>In your Distribution, in your network</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/** end row */}



                            <div className="row">
                                <div className="col-12">
                                    <div>
                                        {/* <div className="card stacked-2 py-5"> */}
                                        {/* <div className="row">
                                <div className="col-xl-3 col-sm-6 widget-inline-box">
                                    <div className="single-chart">
                                        <span className="py-3 border-color-1 rounded-circle border-primary">
                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M26.9165 1.41669H7.08317C5.58028 1.41669 4.13894 2.01371 3.07623 3.07642C2.01353 4.13912 1.4165 5.58046 1.4165 7.08335V17C1.4165 17.3757 1.56576 17.7361 1.83144 18.0018C2.09711 18.2674 2.45745 18.4167 2.83317 18.4167H9.9165V31.1667C9.91583 31.4376 9.99289 31.7031 10.1385 31.9316C10.2842 32.1601 10.4923 32.342 10.7382 32.4559C10.9847 32.5693 11.2585 32.6096 11.5273 32.5719C11.796 32.5343 12.0482 32.4202 12.254 32.2434L16.2915 28.7867L20.329 32.2434C20.5856 32.4628 20.9122 32.5834 21.2498 32.5834C21.5875 32.5834 21.9141 32.4628 22.1707 32.2434L26.2082 28.7867L30.2457 32.2434C30.5023 32.4628 30.8289 32.5834 31.1665 32.5834C31.3715 32.5819 31.574 32.5385 31.7615 32.4559C32.0074 32.342 32.2155 32.1601 32.3612 31.9316C32.5068 31.7031 32.5838 31.4376 32.5832 31.1667V7.08335C32.5832 5.58046 31.9862 4.13912 30.9234 3.07642C29.8607 2.01371 28.4194 1.41669 26.9165 1.41669ZM4.24984 15.5834V7.08335C4.24984 6.33191 4.54835 5.61124 5.0797 5.07988C5.61105 4.54853 6.33172 4.25002 7.08317 4.25002C7.83462 4.25002 8.55529 4.54853 9.08664 5.07988C9.61799 5.61124 9.9165 6.33191 9.9165 7.08335V15.5834H4.24984ZM29.7498 28.0925L27.129 25.84C26.8724 25.6205 26.5458 25.4999 26.2082 25.4999C25.8705 25.4999 25.5439 25.6205 25.2873 25.84L21.2498 29.2967L17.2123 25.84C16.9557 25.6205 16.6292 25.4999 16.2915 25.4999C15.9538 25.4999 15.6273 25.6205 15.3707 25.84L12.7498 28.0925V7.08335C12.7481 6.08812 12.4842 5.1109 11.9848 4.25002H26.9165C27.668 4.25002 28.3886 4.54853 28.92 5.07988C29.4513 5.61124 29.7498 6.33191 29.7498 7.08335V28.0925ZM26.9165 8.50002C26.9165 8.87574 26.7673 9.23608 26.5016 9.50175C26.2359 9.76743 25.8756 9.91669 25.4998 9.91669H16.9998C16.6241 9.91669 16.2638 9.76743 15.9981 9.50175C15.7324 9.23608 15.5832 8.87574 15.5832 8.50002C15.5832 8.1243 15.7324 7.76396 15.9981 7.49829C16.2638 7.23261 16.6241 7.08335 16.9998 7.08335H25.4998C25.8756 7.08335 26.2359 7.23261 26.5016 7.49829C26.7673 7.76396 26.9165 8.1243 26.9165 8.50002ZM26.9165 14.1667C26.9165 14.5424 26.7673 14.9027 26.5016 15.1684C26.2359 15.4341 25.8756 15.5834 25.4998 15.5834H16.9998C16.6241 15.5834 16.2638 15.4341 15.9981 15.1684C15.7324 14.9027 15.5832 14.5424 15.5832 14.1667C15.5832 13.791 15.7324 13.4306 15.9981 13.165C16.2638 12.8993 16.6241 12.75 16.9998 12.75H25.4998C25.8756 12.75 26.2359 12.8993 26.5016 13.165C26.7673 13.4306 26.9165 13.791 26.9165 14.1667ZM26.9165 19.8334C26.9165 20.2091 26.7673 20.5694 26.5016 20.8351C26.2359 21.1008 25.8756 21.25 25.4998 21.25H16.9998C16.6241 21.25 16.2638 21.1008 15.9981 20.8351C15.7324 20.5694 15.5832 20.2091 15.5832 19.8334C15.5832 19.4576 15.7324 19.0973 15.9981 18.8316C16.2638 18.5659 16.6241 18.4167 16.9998 18.4167H25.4998C25.8756 18.4167 26.2359 18.5659 26.5016 18.8316C26.7673 19.0973 26.9165 19.4576 26.9165 19.8334Z" fill="#858585"></path>
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="text-center p-3">
                                        <h2 className="mt-2">
                                            <b>{seriesNumber}</b></h2>
                                        <p className="text-muted mb-0 font-18">Total series assigned
                                        </p>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-sm-6 widget-inline-box">
                                    <div className="single-chart">
                                        <span className="py-3 border-color-1 rounded-circle border-success">
                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M26.9165 1.41669H7.08317C5.58028 1.41669 4.13894 2.01371 3.07623 3.07642C2.01353 4.13912 1.4165 5.58046 1.4165 7.08335V17C1.4165 17.3757 1.56576 17.7361 1.83144 18.0018C2.09711 18.2674 2.45745 18.4167 2.83317 18.4167H9.9165V31.1667C9.91583 31.4376 9.99289 31.7031 10.1385 31.9316C10.2842 32.1601 10.4923 32.342 10.7382 32.4559C10.9847 32.5693 11.2585 32.6096 11.5273 32.5719C11.796 32.5343 12.0482 32.4202 12.254 32.2434L16.2915 28.7867L20.329 32.2434C20.5856 32.4628 20.9122 32.5834 21.2498 32.5834C21.5875 32.5834 21.9141 32.4628 22.1707 32.2434L26.2082 28.7867L30.2457 32.2434C30.5023 32.4628 30.8289 32.5834 31.1665 32.5834C31.3715 32.5819 31.574 32.5385 31.7615 32.4559C32.0074 32.342 32.2155 32.1601 32.3612 31.9316C32.5068 31.7031 32.5838 31.4376 32.5832 31.1667V7.08335C32.5832 5.58046 31.9862 4.13912 30.9234 3.07642C29.8607 2.01371 28.4194 1.41669 26.9165 1.41669ZM4.24984 15.5834V7.08335C4.24984 6.33191 4.54835 5.61124 5.0797 5.07988C5.61105 4.54853 6.33172 4.25002 7.08317 4.25002C7.83462 4.25002 8.55529 4.54853 9.08664 5.07988C9.61799 5.61124 9.9165 6.33191 9.9165 7.08335V15.5834H4.24984ZM29.7498 28.0925L27.129 25.84C26.8724 25.6205 26.5458 25.4999 26.2082 25.4999C25.8705 25.4999 25.5439 25.6205 25.2873 25.84L21.2498 29.2967L17.2123 25.84C16.9557 25.6205 16.6292 25.4999 16.2915 25.4999C15.9538 25.4999 15.6273 25.6205 15.3707 25.84L12.7498 28.0925V7.08335C12.7481 6.08812 12.4842 5.1109 11.9848 4.25002H26.9165C27.668 4.25002 28.3886 4.54853 28.92 5.07988C29.4513 5.61124 29.7498 6.33191 29.7498 7.08335V28.0925ZM26.9165 8.50002C26.9165 8.87574 26.7673 9.23608 26.5016 9.50175C26.2359 9.76743 25.8756 9.91669 25.4998 9.91669H16.9998C16.6241 9.91669 16.2638 9.76743 15.9981 9.50175C15.7324 9.23608 15.5832 8.87574 15.5832 8.50002C15.5832 8.1243 15.7324 7.76396 15.9981 7.49829C16.2638 7.23261 16.6241 7.08335 16.9998 7.08335H25.4998C25.8756 7.08335 26.2359 7.23261 26.5016 7.49829C26.7673 7.76396 26.9165 8.1243 26.9165 8.50002ZM26.9165 14.1667C26.9165 14.5424 26.7673 14.9027 26.5016 15.1684C26.2359 15.4341 25.8756 15.5834 25.4998 15.5834H16.9998C16.6241 15.5834 16.2638 15.4341 15.9981 15.1684C15.7324 14.9027 15.5832 14.5424 15.5832 14.1667C15.5832 13.791 15.7324 13.4306 15.9981 13.165C16.2638 12.8993 16.6241 12.75 16.9998 12.75H25.4998C25.8756 12.75 26.2359 12.8993 26.5016 13.165C26.7673 13.4306 26.9165 13.791 26.9165 14.1667ZM26.9165 19.8334C26.9165 20.2091 26.7673 20.5694 26.5016 20.8351C26.2359 21.1008 25.8756 21.25 25.4998 21.25H16.9998C16.6241 21.25 16.2638 21.1008 15.9981 20.8351C15.7324 20.5694 15.5832 20.2091 15.5832 19.8334C15.5832 19.4576 15.7324 19.0973 15.9981 18.8316C16.2638 18.5659 16.6241 18.4167 16.9998 18.4167H25.4998C25.8756 18.4167 26.2359 18.5659 26.5016 18.8316C26.7673 19.0973 26.9165 19.4576 26.9165 19.8334Z" fill="#858585"></path>
                                            </svg>
                                        </span>
                                    </div>

                                    <div className="text-center p-3">
                                        <h2 className="mt-2"><i className="text-teal mdi mdi-airplay mr-2"></i>
                                            <b>{vouchersValid}</b></h2>
                                        <p className="text-muted mb-0 font-18">Total number of vouchers</p>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-sm-6 widget-inline-box">
                                    <div className="single-chart">
                                        <span className="py-3 border-color-1 rounded-circle  border-info">
                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M32.3668 9.72969C30.9793 6.78884 28.782 4.31932 26.0137 2.58667C22.1634 0.18354 17.6028 -0.579886 13.1815 0.442442C8.7603 1.45813 4.99628 4.14008 2.59315 7.9904C0.183379 11.8407 -0.580047 16.3947 0.44228 20.8226C1.46461 25.2438 4.14656 29.0079 7.99024 31.411C10.6987 33.1038 13.8056 34 16.9854 34H17.1912C20.3577 33.9602 23.438 33.0441 26.1067 31.3579C26.8834 30.8666 27.1091 29.8443 26.6178 29.0676C26.1266 28.2909 25.1043 28.0652 24.3276 28.5564C22.1833 29.9173 19.7005 30.6542 17.1514 30.6874C14.5358 30.7206 11.98 29.997 9.74944 28.6095C6.64927 26.6711 4.49176 23.644 3.67522 20.0857C2.85869 16.5275 3.46943 12.8631 5.40787 9.76288C9.40424 3.37001 17.8617 1.4183 24.2545 5.41467C26.4851 6.80875 28.2509 8.79366 29.3662 11.157C30.4549 13.4605 30.8797 16.0163 30.5943 18.539C30.4947 19.4484 31.1453 20.2716 32.0614 20.3712C32.9709 20.4708 33.794 19.8202 33.8936 18.9041C34.2455 15.7641 33.7144 12.5909 32.3668 9.72969Z" fill="#2BC155"></path>
                                                <path d="M22.4914 11.2377L14.4846 19.2445L11.5169 16.2768C10.8663 15.6262 9.81732 15.6262 9.16669 16.2768C8.51605 16.9274 8.51605 17.9764 9.16669 18.6271L13.3095 22.7699C13.6348 23.0952 14.0597 23.2545 14.4846 23.2545C14.9095 23.2545 15.3345 23.0952 15.6598 22.7699L24.8351 13.588C25.4857 12.9373 25.4857 11.8883 24.8351 11.2377C24.1844 10.5937 23.1354 10.5937 22.4914 11.2377Z" fill="#2BC155"></path>
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="text-center p-3">
                                        <h2 className="mt-2"><i className="text-info mdi mdi-ticket mr-2"></i>
                                            <b>{voucherDifference}</b></h2>
                                        <p className="text-muted mb-0 font-18">Vouchers valid
                                        </p>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-sm-6">
                                    <div className="single-chart">
                                        <span className="py-3 border-color-1 rounded-circle  border-danger">
                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0)">
                                                    <path d="M32.3733 9.72855C30.9854 6.78675 28.7873 4.31644 26.0182 2.58323C22.1666 0.179327 17.6112 -0.584345 13.1819 0.438311C8.75922 1.45433 4.99399 4.13714 2.59008 7.9887C0.179532 11.8403 -0.58414 16.3957 0.438516 20.825C1.46117 25.2477 4.14399 29.0129 7.98891 31.4168C10.6983 33.1102 13.8061 34.0067 16.987 34.0067H17.1928C20.3604 33.9668 23.4416 33.0504 26.1112 31.3637C26.8881 30.8723 27.1139 29.8496 26.6225 29.0727C26.1311 28.2957 25.1084 28.07 24.3315 28.5614C22.1866 29.9227 19.703 30.6598 17.153 30.693C14.5366 30.7262 11.9799 30.0024 9.74867 28.6145C6.6475 26.6754 4.4893 23.6473 3.6725 20.0879C2.8557 16.5153 3.46664 12.8496 5.4057 9.74847C9.40336 3.35355 17.8635 1.4012 24.2584 5.39886C26.4897 6.79339 28.2561 8.77894 29.3717 11.143C30.4608 13.4473 30.8858 16.0039 30.6002 18.5274C30.5006 19.4371 31.1514 20.2606 32.0678 20.3602C32.9776 20.4598 33.801 19.809 33.9006 18.8926C34.2526 15.7649 33.7213 12.5907 32.3733 9.72855Z" fill="#FF2E2E"></path>
                                                    <path d="M22.7647 11.2359C22.114 10.5852 21.0647 10.5852 20.414 11.2359L17.0007 14.6559L13.5874 11.2426C12.9366 10.5918 11.8874 10.5918 11.2366 11.2426C10.5858 11.8934 10.5858 12.9426 11.2366 13.5934L14.6499 17.0066L11.2366 20.4199C10.5858 21.0707 10.5858 22.1199 11.2366 22.7707C11.562 23.0961 11.987 23.2555 12.412 23.2555C12.837 23.2555 13.262 23.0961 13.5874 22.7707L17.0007 19.3574L20.414 22.7707C20.7394 23.0961 21.1644 23.2555 21.5894 23.2555C22.0144 23.2555 22.4394 23.0961 22.7647 22.7707C23.4155 22.1199 23.4155 21.0707 22.7647 20.4199L19.3515 17L22.7647 13.5867C23.4155 12.9359 23.4155 11.8867 22.7647 11.2359Z" fill="#FF2E2E"></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0">
                                                        <rect width="34" height="34" fill="white"></rect>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="text-center p-3">
                                        <h2 className="mt-2"><i className="text-info mdi mdi-ticket mr-2"></i>
                                            <b>{vouchersUsed}</b></h2>
                                        <p className="text-muted mb-0 font-18">Vouchers Used

                                        </p>
                                    </div>

                                </div>

                            </div> */}

                                        <Space direction="horizontal" >
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<HddOutlined
                                                        style={{
                                                            color: "#1576ED",
                                                            backgroundColor: "White",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Total Pins Assigned"} value={countAllPins} />
                                                </Col>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<FileDoneOutlined
                                                        style={{
                                                            color: "#1576ED",
                                                            backgroundColor: "White",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Pins in Dealers"} value={countSubContractore} />

                                                </Col>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<CheckCircleOutlined
                                                        style={{
                                                            color: "green",
                                                            backgroundColor: "white",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Used Donimination"} value={countUsedDonomination} />

                                                </Col>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<CheckCircleOutlined
                                                        style={{
                                                            color: "green",
                                                            backgroundColor: "white",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Unused donimination"} value={countUnsedDonomination} />

                                                </Col>

                                            </Row>
                                        </Space>

                                        <Space direction="horizontal" style={{ marginTop: 10 }}>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<HddOutlined
                                                        style={{
                                                            color: "#1576ED",
                                                            backgroundColor: "White",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Supervisor"} value={countSupervisor} />
                                                </Col>

                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<FileDoneOutlined
                                                        style={{
                                                            color: "#1576ED",
                                                            backgroundColor: "White",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Agents"} value={countAgent} />
                                                </Col>

                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<CheckCircleOutlined
                                                        style={{
                                                            color: "green",
                                                            backgroundColor: "white",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Distributor"} value={countDistributor} />

                                                </Col>
                                                <Col xs={24} sm={12} md={8} lg={6}>
                                                    <TransactionCard icon={<CloseCircleOutlined
                                                        style={{
                                                            color: "red",
                                                            backgroundColor: "white",
                                                            borderRadius: 20,
                                                            padding: 12,
                                                            fontSize: 18,
                                                            boxShadow: '30px 30px 30px 30px #f5f5f5'
                                                        }}
                                                    />}
                                                        title={"Vendors"} value={countVendor} />
                                                </Col>

                                            </Row>
                                        </Space>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                            {/** end row */}
                            {
                                isMatch ? (<></>) :
                                    (<>
                                        <div className="mt-2">

                                            <Card style={{ width: '100%' }}>

                                                {
                                                    isMatch ? (
                                                        <table style={{
                                                            border: '1px solid black',
                                                            width: '100%',
                                                            borderColor: '#F2F2F2',
                                                            display: 'row'
                                                        }}>

                                                            <tbody >
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Title" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Denomination" />
                                                                        </div>
                                                                    </td >
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Selling Price" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Operrator</option>
                                                                            </select>
                                                                        </div>

                                                                    </td>
                                                                </tr>

                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Category</option>
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Currency</option>
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td colSpan={2} style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="date" className="form-control" />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <button className="w-100" style={{
                                                                                background: '#4691EE', borderColor: '#4691EE', color: 'white',
                                                                                padding: 2
                                                                            }}><SearchOutlined />Filter</button>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <button className="w-100" style={{
                                                                                background: '#39A945', color: 'white', borderColor: '#39A945',
                                                                                padding: 2
                                                                            }}><FileExcelOutlined />Export</button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    ) : (
                                                        <table style={{
                                                            border: '1px solid black',
                                                            width: '100%',
                                                            borderColor: '#F2F2F2'
                                                        }}>
                                                            <tbody >
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Title" />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Denomination" />
                                                                        </div>
                                                                    </td >
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="text" className="form-control" placeholder="Selling Price" />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Operrator</option>
                                                                            </select>
                                                                        </div>

                                                                    </td>
                                                                </tr>
                                                                <tr style={{ border: '1px solid #F0F0F0' }}>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Category</option>
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <select className="form-control">
                                                                                <option value="">All Currency</option>
                                                                            </select>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <input type="date" className="form-control" />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <button className="w-100" style={{
                                                                                background: '#4691EE', borderColor: '#4691EE', color: 'white',
                                                                                padding: 2
                                                                            }}><SearchOutlined />Filter</button>
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ border: '1px solid #F0F0F0' }}>
                                                                        <div className="inputBox m-1">
                                                                            <button className="w-100" style={{
                                                                                background: '#39A945', color: 'white', borderColor: '#39A945',
                                                                                padding: 2
                                                                            }}><FileExcelOutlined />Export</button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    )
                                                }


                                            </Card>

                                        </div >
                                    </>)
                            }


                            {/** table */}

                            {
                                isMatch ? (
                                    <>
                                        <div className="mt-2">

                                            <Card style={{ width: '100%' }}>
                                                <Input style={{ color: 'black' }} size="large" placeholder="Searh here..." prefix={<SearchOutlined />} />
                                                <span className="fs-12" style={{ paddingTop: 30, paddingBottom: 30 }}>List vouhers assigned</span>
                                                <div style={{ width: '100%' }}>
                                                    {
                                                        inventory.map((item, i) => (
                                                            <div key={i} className="d-flex pb-3 border-bottom mb-3 ">
                                                                <div className="">
                                                                    <div className='col-12'>
                                                                        <div className='row'>

                                                                            <div className='col-10'>
                                                                                <div style={{ display: 'flex' }}>

                                                                                    <div >
                                                                                        <img src={logoLight} alt="" className="rounded-circle mr-1" width="80" /><br />
                                                                                        <strong style={{ color: '#68C3EE' }}>{item.reference}</strong>
                                                                                    </div>


                                                                                </div>
                                                                                <h6 className="fs-16 font-w600 mb-0 " >
                                                                                    <span>Seller:{item.seller_name}</span>

                                                                                </h6>
                                                                                <span className="fs-12">{item.gender} | Type : {item.seller_role} <br />
                                                                                    <div style={{
                                                                                        backgroundColor: '#D9DCE1', paddingLeft: 20, paddingRight: 20,
                                                                                        paddingTop: 2, paddingBottom: 2, fontSize: 16, marginLeft: 10, marginTop: 5
                                                                                    }} onClick={() => showDrawer(item)}>Views Details</div> </span>
                                                                            </div>

                                                                            <div className='col-2' style={{ width: 100 }}>
                                                                                <div className="dropdown" >
                                                                                    <button className="dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                                                                                        <MoreOutlined style={{ fontSize: 30 }} />
                                                                                    </button>
                                                                                    <div className="dropdown-menu dropdown-menu-right" >
                                                                                        <Link className="dropdown-item" to="">More</Link>

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                </div>

                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                <Pagination
                                                    style={{
                                                        paddingTop: 0,
                                                        paddingBottom: 10
                                                    }}
                                                    pageSize={10}
                                                    total={totalPage}
                                                    onChange={(page: any) => {
                                                        // loadSeller(page)
                                                    }}
                                                />
                                            </Card>


                                        </div>
                                    </>
                                ) : (
                                    <>
                                        < div className="col-xl-12" >
                                            <div className="card row mt-3 ">

                                                <div className="card-body payment-bx tab-content p-0">
                                                    <div className="tab-pane active show fade" role="tabpanel">
                                                        <div className="card-body">
                                                            <div className="table-responsive">
                                                                <table className="table header-border table-responsive-sm tbl-common">


                                                                    <thead style={{
                                                                        height: 5
                                                                        // borderBottom: '1px 1px solid #E3E3E3 !important'
                                                                    }}>

                                                                        <tr style={{ height: 5 }}>
                                                                            {/* <th style={{ width: 40, paddingLeft: 2, }}>#</th> */}
                                                                            <th style={{ borderLeft: '2px solid #ffffff', }}>Inventory# </th>
                                                                            <th style={{ borderLeft: '2px solid #ffffff' }}>Total vouchers</th>
                                                                            <th style={{ borderLeft: '2px solid #ffffff' }}>Operators</th>
                                                                            <th style={{ borderLeft: '2px solid #ffffff' }}>Status</th>
                                                                            <th style={{ borderLeft: '2px solid #ffffff' }}>Finance</th>
                                                                            <th colSpan={2} style={{ borderLeft: '2px solid #ffffff' }}>Distribution channel</th>
                                                                            {/* <th style={{ borderLeft: '2px solid #ffffff' }}>More</th> */}

                                                                        </tr>
                                                                    </thead>

                                                                    <tbody id="tab_">
                                                                        {/* {
                        LoadVoucher.map((item, i) => (
                            <tr key={i}>
                                <td>{item.series}</td>
                                <td>{item.type}</td>
                                <td>{item.count}</td>
                                <td><span className="btn btn-sm btn-success light btn-radius">{item.amount}</span></td>
                                <td style={{ width: 15 }}>
                                    <span className={getUsed(item.voucher_used)[0]}>{getUsed(item.voucher_used)[1]}</span>
                                </td>

                                <td><span className={getTransfer(item.status)[0]}><i
                                    className="fa fa-circle text-success me-1"></i>{getTransfer(item.is_transfered)[1]}</span>

                                </td>
                                <td>{item.date}</td>
                            </tr>
                        ))
                    } */}
                                                                        {
                                                                            inventory.map((item, i) => (
                                                                                <tr key={i} style={{ borderBottom: '1px solid #E8E8E8' }}>
                                                                                    {/* <td scope="row" style={{ width: 10, paddingLeft: 2, paddingRight: 8, color: "black", fontSize: 20 }}>
                    1
                </td> */}
                                                                                    <td >
                                                                                        <img src={logoLight} style={{ width: 100, }} /><br />
                                                                                        <div style={{ marginBottom: 10 }}><strong style={{ color: '#68C3EE' }}>{item.reference}</strong></div>
                                                                                        <div><strong style={{ paddingTop: 50 }}>{api.formatDate(item.date)}</strong></div>
                                                                                        <div><strong style={{ paddingTop: 50 }}>{api.geDateFormat(item.date)}</strong></div>

                                                                                    </td>
                                                                                    <td  >
                                                                                        <div>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Currency:</strong> {item.currency}.{item.status.amount}</p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Donimination:</strong><br />{item.donimination} </p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Customer selling price:</strong><br /> {item.currency}.{item.customer_selling_price}</p>
                                                                                            <p><strong style={{ fontSize: 16 }}>Inventory order total:</strong><br /> {item.currency}.{parseInt(item.donimination) * parseInt(item.customer_selling_price)}</p>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td >
                                                                                        <div>
                                                                                            {item.mobile_operator.map((operator) => (
                                                                                                <p key={operator} style={{ marginBottom: '10px' }}>
                                                                                                    {operator}
                                                                                                </p>
                                                                                            ))}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td  >
                                                                                        <div >
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Used:</strong> {item.status.used}</p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Asigned:</strong><br /> {item.status.asigned}</p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Available:</strong><br /> {item.status.available}</p>
                                                                                        </div>

                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16, }}>Used:</strong> <br />{item.currency}.{item.finance_used}</p>
                                                                                            <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 30 }}>
                                                                                                <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Supposed received</strong>
                                                                                                    <br /><strong>to Tiva: </strong>{item.currency}.{item.finance_supposed_received}</p>
                                                                                            </Badge>
                                                                                            <br />
                                                                                            <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 30 }}>
                                                                                                <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Paid received:</strong><br />{item.currency}.{item.paid_amount}</p>
                                                                                            </Badge>

                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16, }}>UNPAID:</strong> {item.currency}.{item.unpaid_amount}</p>
                                                                                            <button style={{
                                                                                                backgroundColor: '#0B6AF8',
                                                                                                color: '#ffffff', borderRadius: 5, borderColor: '#0B6AF8',
                                                                                                height: 25, paddingBottom: 5, marginRight: 10
                                                                                            }}
                                                                                                onClick={() => showModal(`${item.seller_phone}`, `${item.id}`, `${item.seller_name}`)}
                                                                                            >Request</button>
                                                                                            <Badge count={5} style={{ backgroundColor: '#52c41a', marginRight: 0, marginTop: 3 }}>

                                                                                            </Badge>

                                                                                        </div>

                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller:</strong> {item.seller_name}</p>
                                                                                            <button style={VerifyKEYC(item.seller_is_kyc)}>{parseInt(item.seller_is_kyc) == 1 ? 'KYC Ok' : 'KYC No'}</button>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Phone:</strong> {item.seller_phone} <br />
                                                                                                {item.seller_email}
                                                                                            </p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Address:</strong> <br />{item.seller_address}</p>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller Type:</strong> {item.seller_role}</p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Place of operation:</strong><br /> Mlole Soko mjinga</p>
                                                                                            <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Operation location type:</strong> <br /> Stand umbrella</p>
                                                                                            <button style={VerifyLicence(item.is_licence)}>{parseInt(item.is_licence) == 1 ? 'License: Ok' : 'License: No'}</button>
                                                                                        </div>

                                                                                    </td>

                                                                                    {/* <td>
                        <button style={{
                            marginTop: 90,
                            backgroundColor: '#F3F6F9',
                            color: 'black', borderColor: '#F3F6F9',
                            borderRadius: 5, height: 30, paddingBottom: 5,
                            width: 80

                        }}>More</button>
                    </td> */}
                                                                                </tr>
                                                                            ))
                                                                        }


                                                                        {/* <tr style={{ borderBottom: '1px solid #E8E8E8' }}>
           
            <td >
                <img src={logoLight} style={{ width: 100, }} /><br />
                <strong style={{ color: '#68C3EE' }}>11252652932</strong><br /><br />
                <strong style={{ paddingTop: 50 }}>2023-03-14 11:54:00</strong>
            </td>
            <td  >
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Currency:</strong> Tsh: 500</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Donimination:</strong> 980</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Network Selling price:</strong> Tsh: 500</p>
                    <p><strong style={{ fontSize: 16 }}>Batch Price:</strong><br /> Tsh: 490.000.00</p>
                </div>
            </td>
            <td >
                <div>
                    <p>Tigo</p>
                    <p>Vodacom</p>
                    <p>Airtel</p>
                </div>
            </td>
            <td  >
                <div >
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Used:</strong> 87</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Asigned:</strong> 187</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Available:</strong> 793</p>
                </div>

            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16, }}>Used:</strong> Tsh.<br /> 4350</p>
                    <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 30 }}>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Supposed Received:</strong>
                            <br /><strong>To tiva: </strong><br /> Tsh: 43500.00</p>
                    </Badge>
                    <br />
                    <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 30 }}>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Paid Received:</strong><br /> Tsh: 43500.00</p>
                    </Badge>

                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16, }}>UNPAID:</strong> Tsh: 00.00</p>
                    <button style={{
                        backgroundColor: '#0B6AF8',
                        color: '#ffffff', borderRadius: 5, borderColor: '#0B6AF8',
                        height: 25, paddingBottom: 5, marginRight: 10
                    }}>Request</button>
                    <Badge count={5} style={{ backgroundColor: '#52c41a', marginRight: 0, marginTop: 3 }}>

                    </Badge>

                </div>

            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller:</strong> Nono Lukinga</p>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderColor: '#00CE69',
                        borderRadius: 5, height: 22, paddingBottom: 5,
                    }}>KYC Ok</button>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Phone:</strong> 797027483 <br />
                        nono@gmail.com
                    </p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Address:</strong> <br />#255 Street Mwananyamala Mwanza</p>
                </div>
            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller Type:</strong> Distributor</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Place of Operation:</strong><br /> Soko Labondeni Tanga</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Operation Location Type:</strong> <br /> Shop in Market</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Business KEY:</strong> Distributor</p>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderRadius: 5, borderColor: '#00CE69',
                        height: 22, paddingTop: 0, paddingBottom: 5,
                        width: 100, marginBottom: 5
                    }}>License: Ok</button>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderRadius: 5, borderColor: '#00CE69',
                        height: 22, paddingTop: 0, paddingBottom: 5,
                        width: 100
                    }}>License: Ok</button>
                </div>

            </td>

            <td>
                <button style={{
                    marginTop: 90,
                    backgroundColor: '#F3F6F9',
                    color: 'black', borderColor: '#F3F6F9',
                    borderRadius: 5, height: 30, paddingBottom: 5,
                    width: 80

                }}>More</button>
            </td>
        </tr>

        <tr style={{ borderBottom: '1px solid #E8E8E8' }}>
          
            <td >
                <img src={logoLight} style={{ width: 100, }} /><br />
                <strong style={{ color: '#68C3EE' }}>11252652002</strong><br /><br />
                <strong style={{ paddingTop: 50 }}>2023-03-14 11:54:00</strong>
            </td>
            <td  >
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Currency:</strong> Tsh: 500</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Donimination:</strong> 200</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Network Selling price:</strong> Tsh: 500.00</p>
                    <p><strong style={{ fontSize: 16 }}>Batch Price:</strong><br /> Tsh: 100.000.00</p>
                </div>
            </td>
            <td >
                <div>
                    <p>Tigo</p>
                    <p>Vodacom</p>
                    <p>Airtel</p>
                </div>
            </td>
            <td  >
                <div >
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Used:</strong> 00</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Asigned:</strong> 45</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Available:</strong> 200</p>
                </div>

            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Used:</strong> Tsh: 00.00</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Supposed Received:</strong> Tsh: 00</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Received:</strong> Tsh: 00.00</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16, }}>UNPAID:</strong> Tsh: 00.00</p>

                </div>

            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller:</strong> Lukas Jumla Maji</p>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderColor: '#00CE69',
                        borderRadius: 5, height: 22, paddingBottom: 5,
                    }}>KYC Ok</button>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Phone:</strong> 797027483 <br />
                        lukas@gmail.com
                    </p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Address:</strong> <br />#255 Street Mwananyamala Mwanza</p>
                </div>
            </td>
            <td>
                <div>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller Type:</strong> Distributor</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Place of Operation:</strong><br /> Mlole Soko Mjinga</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Operation Location Type:</strong> <br /> Stand Umbrella</p>
                    <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Business KEY:</strong> Distributor</p>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderRadius: 5, borderColor: '#00CE69',
                        height: 22, paddingTop: 0, paddingBottom: 5,
                        width: 100, marginBottom: 5
                    }}>License: Ok</button>
                    <button style={{
                        backgroundColor: '#00CE69',
                        color: 'black', borderRadius: 5, borderColor: '#00CE69',
                        height: 22, paddingTop: 0, paddingBottom: 5,
                        width: 100
                    }}>License: Ok</button>
                </div>

            </td>

            <td>
                <button style={{
                    marginTop: 90,
                    backgroundColor: '#F3F6F9',
                    color: 'black', borderColor: '#F3F6F9',
                    borderRadius: 5, height: 30, paddingBottom: 5,
                    width: 80

                }}>More</button>
            </td>
        </tr> */}


                                                                    </tbody>
                                                                </table>
                                                            </div>


                                                            <nav>
                                                                <div className="pagination pagination-lg mb-0">
                                                                    <Pagination
                                                                        style={{
                                                                            paddingTop: 10

                                                                        }}
                                                                        responsive
                                                                        pageSizeOptions={[10, 20, 30, 40]}
                                                                        pageSize={10}
                                                                        total={totalPage}
                                                                        onChange={(page: any) => {
                                                                            loadInventory(page)
                                                                        }}
                                                                    />
                                                                </div>
                                                            </nav>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            {/** table */}

                        </div >
                        <Footer />
                    </div>
                </div>
            </div>


            <Modal
                title="REQUEST"
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                footer={false}
            >
                <>
                    <div className="modal-body">
                        <h2 className="font-24 text-center font-weight-normal">Seller name: {nameSeller}
                        </h2>
                        <input type="text" name='id' value={id} onChange={(e) => setId(e.target.value)} style={{ display: "none" }} />
                        <div className="basic-form">
                            <div className="mb-3">
                                <label className="form-label">Phone</label>
                                <input type="text" id="montant" className="default-select form-control wide"
                                    placeholder="Phone numbe" value={phone} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea id="montant" className="default-select form-control wide"
                                    placeholder="Message Request" rows={5}
                                />
                            </div>
                            <div className="select-card-wrapper" id="packe"></div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary agree-link font-18" disabled={true}
                            id="btn-Withdraw">Send Request</button>
                    </div>
                </>
            </Modal>

            <Drawer
                title={`Voucher assigned details`}
                placement={'bottom'}
                width={500}
                height={500}
                onClose={closeDrawer}
                open={openDawer}

            >

                <div style={{ display: 'flex', marginTop: 0 }}>
                    <label style={{
                        backgroundColor: 'red',
                        height: 20,
                        width: 8,
                        borderRadius: 10
                    }}></label>
                    <div style={{ marginLeft: 2 }}>
                        <h5 style={{ color: 'black' }}>Inventory#</h5>
                    </div>

                </div>

                <div style={{ display: 'flex', marginTop: 0 }}>
                    <div style={{ marginLeft: 1 }}>

                        <img src={logoLight} style={{ width: 100, }} /><br />
                        <strong style={{ color: '#68C3EE' }}>{reference}</strong><br />
                        <strong >{api.geDateFormat(date)}</strong>
                    </div>

                </div><hr />

                <div style={{ display: 'flex', }}>
                    <div style={{ marginLeft: 1, marginRight: 40 }}>
                        <h6 style={{ color: 'black' }}>* Total vouchers</h6>
                        <p ><strong >Currency:</strong> {currency}</p>
                        <p ><strong >Donimination:</strong>{donimination} </p>
                        <p ><strong >Customer selling price:</strong> {customerSellingPrice}</p>
                        <p><strong >Inventory order total:</strong> {parseInt(donimination) * parseInt(customerSellingPrice)}</p>
                    </div>
                    <label style={{
                        backgroundColor: 'red',
                        height: 110,
                        width: 4,
                        borderRadius: 10
                    }}></label>
                    <div style={{ marginRight: 0, marginLeft: 2 }}>
                        <h6 style={{ color: 'red' }}>Operators</h6>
                        {mobileOperator.map((operator) => (
                            <p key={operator} style={{ marginBottom: '10px' }}>
                                {operator}
                            </p>
                        ))}
                    </div>
                </div><hr />

                <div style={{ display: 'flex', }}>
                    <div style={{ marginLeft: 1, marginRight: 15 }}>
                        <h6 style={{ color: 'red' }}>* Status</h6>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Used:</strong> {used}</p>

                    </div>

                    <div style={{ marginLeft: 1, marginRight: 15 }}>
                        <h6 style={{ color: 'white' }}>* Status</h6>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Asigned:</strong> {assigned}</p>
                    </div>
                    <div style={{ marginLeft: 1, }}>
                        <h6 style={{ color: 'white' }}>* Status</h6>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Available:</strong> {available}</p>
                    </div>


                </div><hr />

                <div style={{ display: 'flex', }}>
                    <div style={{ marginRight: 40 }}>
                        <h6 style={{ color: 'black', }}>* Financy</h6>
                        <p style={{ marginBottom: 1 }}><strong >Used:</strong>   {financeUsed}</p>
                        <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 1 }}>
                            <p style={{ marginBottom: 1 }}><strong >Supposed received</strong>
                                <br /><strong>to Tiva: </strong>{financeSupposedReceived}</p>
                        </Badge>


                    </div>
                    <div>
                        <h6 style={{ color: 'white' }}>Suite financy</h6>
                        <Badge count={5} size="small" style={{ backgroundColor: 'red', marginRight: 0, marginTop: 1 }}>
                            <p style={{ marginBottom: 1 }}><strong >Paid received:</strong>{paidAmount}</p>
                        </Badge>

                        <p style={{ marginBottom: 1 }}><strong >UNPAID:</strong> {unpaidAmount}</p>
                        <button style={{
                            backgroundColor: '#0B6AF8',
                            color: '#ffffff', borderRadius: 5, borderColor: '#0B6AF8',
                            height: 25, paddingBottom: 5, marginRight: 10
                        }}
                            onClick={() => showModal(`${showSellerPhone}`, `${showId}`, `${showSellerName}`)}
                        >Request</button>
                    </div>


                </div><hr />

                <div style={{ display: 'flex' }}>
                    <div>
                        <h6 style={{ color: 'black', }}>* Distribution channel</h6>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller:</strong>
                            <strong style={{ marginBottom: 5, fontSize: 16, color: 'black' }}> {nameSeler}</strong></p>

                        <button style={VerifyKEYC(sellerIsKyc)}>{parseInt(sellerIsKyc) == 1 ? 'KYC Ok' : 'KYC No'}</button>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Phone:</strong> {sellerPhone} <br />
                            {sellerEmail}
                        </p>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Address:</strong> #255 Street mwananyamala mwanza</p>


                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Seller Type:</strong> {sellerRole}</p>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Place of operation:</strong> Mlole Soko mjinga</p>
                        <p style={{ marginBottom: 1 }}><strong style={{ fontSize: 16 }}>Operation location type:</strong>  Stand umbrella</p>
                        <button style={VerifyLicence(sellerIsLicence)}>{parseInt(sellerIsLicence) == 1 ? 'License: Ok' : 'License: No'}</button>

                    </div>
                </div>

            </Drawer>

        </>
    )
}

function TransactionCard({ title, value, icon }: any) {
    return (

        <Card
            hoverable
            style={{ width: 330, boxSizing: 'border-box', padding: 10 }}
            bodyStyle={{ display: 'table', width: '100%' }}

        >
            <Space >

                <Statistic style={{ color: "black" }} value={value}
                    valueStyle={{ color: 'black', fontSize: '26px' }}
                    title={<Title level={3} style={{ fontSize: '16px' }}>{title}</Title>}
                />

                {icon}

            </Space>

        </Card>
    )
}


export default VoucherDistribution
